// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3x--q","bigColWidth":"Table_bigColWidth__3R4Mu","biggerColWidth":"Table_biggerColWidth__2ixcc","row":"Table_row__ncSbd","col":"Table_col__3mUmz"};